<template>
    <div style="width:100%; box-sizing: border-box; text-align: left;">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>

        <div class="frm_subcont" v-show="InitDone">

            <div class="frm_infotext" v-show="Sikeres==1">
                <div class="frm_infotext_icon">
                <i class="fal fa-check-circle" style="font-size:60px; line-height:60px; color:var(--themecolor6);"></i>
                </div>
                <div class="frm_infotext_title" v-html="strResult"></div>
                <div class="frm_infotext_osszeg" v-html="strOsszeg" v-show="IsTokenReg==0"></div>
                <!--
                <div class="frm_infotext_fedezeti_osszeg_title" v-show="IsTokenReg==0">Fedezetre jutó elkölthető összeg:</div>
                <div class="frm_infotext_fedezeti_osszeg" v-html="strFedezetiOsszeg" v-show="IsTokenReg==0"></div>
                -->
                <div class="frm_infotext_simpleazon">SimplePay azonosító: {{PayRefNo}}</div>
            </div>

            <div class="frm_infotext" v-show="Sikeres==0">
                <div class="frm_infotext_title" v-html="strResult"></div>
            </div>

            <div class="frm_btncont" style="margin:20px 0px;">
                <a :href="ButtonUrl" class="painted_linkbutton2 color3">
                <span>{{ButtonText}}<i class="fal fa-angle-double-right" style="margin-left: 10px;"></i></span>
                </a>
            </div>

        </div>


    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'


export default {
  name: 'frmsimplebackref',
  components: {
      GrcDB,
      GrcDialog,
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmSimpleBackRef_",
            gPopupControlName:"",

            InitDone:false,
            Sikeres:-1,
            ButtonUrl:"",
            ButtonText:"",
            PayRefNo:"",
            strResult:"",
            strOsszeg:"",
            strFedezetiOsszeg:"",
            IsTokenReg:0,

      }
  },
  model: {
  },  
  methods:{

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmSimpleBackRef", pCompName);
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }

        this.$refs[pNextComp].SetFocus();
    },


    SetLang()
    {
        this.Init();
    },

    async Init()
    {
    let Refnum = "";
    if (GRCAPP_GetParameters.hasOwnProperty("PC_REFNUM"))
    {
        try
        {
        Refnum = GRCAPP_GetParameters.PC_REFNUM;
        } catch(err)
        {
        Refnum = "";
        }
    }



    
    this.$refs.GRCDB.ShowLoading(false);

    var QP = {
        sRefnum: Refnum
    };

    var Q;
    await this.$refs.GRCDB.GetData(this.WSPREFIX + "CheckResult", QP).then(res => { Q = res; });


    if (Q.APPERR[0].ERR != "")
    {
        this.$refs.GRCDB.HideLoading();
        this.ShowInfoDialog(Q.APPERR[0].ERR, 200);
        return;
    }
    

    this.$refs.GRCDB.HideLoading();
    
    this.Sikeres = Q.RESULT[0].intResult;
    this.ButtonUrl = Q.RESULT[0].ButtonUrl;
    this.ButtonText = Q.RESULT[0].ButtonText;
    this.PayRefNo = Q.RESULT[0].PayRefNo;
    this.strResult = Q.RESULT[0].strResult;
    this.strOsszeg = Q.RESULT[0].strSikeresOsszeg;
    this.strFedezetiOsszeg = Q.RESULT[0].strFedezetiOsszeg;
    this.IsTokenReg = Q.RESULT[0].IsTokenReg;
    
    
    this.InitDone = true;

    },



    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>


.frm_pos
{
  width:100%;
  box-sizing: border-box;
  font-size:1px;
  line-height:1px;
  opacity:0;
  margin-top:10px;
}

.frm_cont
{
  width:100%;
  box-sizing: border-box;
  margin:10px auto;
  text-align: left;
  
}


.frm_btncont
{
  width:100%;
  box-sizing: border-box;
  text-align: center;
}

.frm_subcont
{
  width:100%;
  box-sizing: border-box;
  padding: 15px;
}


.frm_infotext
{
  width:100%;
  box-sizing: border-box;
  display:block;
  text-align:center;
  padding:15px;
}

.frm_infotext_icon
{
  width:100%;
  box-sizing: border-box;
  display:block;
  text-align:center;
  padding:15px;
  padding-top:0px;
}

.frm_infotext_title
{
  width:100%;
  box-sizing: border-box;
  display:block;
  text-align:center;
  font-size:18px;
  line-height:24px;
  color:#000;
  font-weight:bold;
  margin:10px 0px;
}

.frm_infotext_osszeg
{
  width:100%;
  box-sizing: border-box;
  display:block;
  text-align:center;
  font-size:30px;
  line-height:30px;
  color:#000;
  font-weight:500;
  margin:20px 0px;
}

.frm_infotext_fedezeti_osszeg_title
{
  width:100%;
  box-sizing: border-box;
  display:block;
  text-align:center;
  font-size:14px;
  line-height:20px;
  color:#000;
  font-weight:500;
  margin:20px 0px;
}

.frm_infotext_fedezeti_osszeg
{
  width:100%;
  box-sizing: border-box;
  display:block;
  text-align:center;
  font-size:24px;
  line-height:24px;
  color:#000;
  font-weight:500;
  margin:20px 0px;
}





.frm_infotext_simpleazon
{
  width:100%;
  box-sizing: border-box;
  display:block;
  text-align:center;
  font-size:16px;
  line-height:24px;
  color:#000;
  font-weight:normal;
  margin:10px 0px;
}



@media(max-width:800px)
{

}


</style>